<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h4 class="font-weight-light">
              <span class="font-weight-bold">Users</span>
            </h4>
          </div>
          <div class="col-sm-6 d-none d-md-block"></div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <Card>
          <div slot="body">
            <UsersTable />
          </div>
        </Card>
      </div>
    </section>
  </div>
</template>

<script>
import UsersTable from "@/components/derived/UsersTable";
import Card from "@/components/core/Card";

export default {
  name: "Users",
  components: { UsersTable, Card }
};
</script>
